import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import React from "react";

const MockTooltipComponent = ({
  title,
  child,
  placement,
  open,
  popper,
  popperArrow,
  tooltipArrowStyle,
  overrideStyles,
  rightPlacement
}) => {
  const CustomTooltip = withStyles({
    tooltip: {
      color: "#FFFFFF",
      backgroundColor: "#373D3F",
      padding: '16px',
      lineHeight: '140%'
    }
  })(Tooltip);

  const myRef = React.useRef(null);

  return (
    <div ref={myRef}>
      <CustomTooltip
        title={title}
        placement={placement}
        arrow
        interactive
        open={open}
        style={overrideStyles}
        classes={{
          popperInteractive: popper,
          popperArrow: popperArrow,
          arrow: tooltipArrowStyle
        }}
        PopperProps={{
          sx: popper,
          popperOptions: {
            modifiers: {
              flip: {
                enabled: false,
              },
              arrow: {
                enabled: true,
              },
              offset: {
                enabled: true,
                offset: '20px, 20px',
              },
              preventOverflow: {
                enabled: true,
                escapeWithReference: true,
                boundariesElement: 'viewport'
              }
            },
          },
        }}
      >
        <div>{child}</div>
      </CustomTooltip>
    </div>
  );
};

export default MockTooltipComponent;
